var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"address",on:{"click":function($event){return _vm.showPopup()}}},[_c('div',{staticClass:"city"},[_vm._v(_vm._s(_vm.city))]),_c('img',{staticStyle:{"width":"12px"},attrs:{"src":require("../assets/pull1.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }